// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { vueAxios } from '@/plugins/axios'
import lodash from '@/plugins/lodash'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueDND from 'awe-dnd'
import 'font-awesome/css/font-awesome.css'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
import PopupVue from './globalComponent/popup/popup'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import directives from '@/utils/directives.js'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
import { initSdk, loadExtensionScript } from './plugins/redcatSdk'
import publishAxios from '@/plugins/publishAxios'
import toolTipComponent from 'echarts/lib/component/tooltip'

// 调试工具 npm i vconsole --save
// import vConsole from 'vconsole'
// // eslint-disable-next-line
// const v = new vConsole()
if (!window.redcatApp) window.redcatApp = {}
Vue.config.productionTip = false
Vue.prototype.$EventBus = new Vue()
Vue.use(AlloyFingerPlugin, {
  AlloyFinger
})

Vue.use(vueAxios)
Vue.use(lodash)
Vue.use(ElementUI, { size: 'mini' })
Vue.use(VueDND)
Vue.use(contentmenu)
Vue.use(PopupVue)
Vue.use(Mint)
Vue.use(directives)
Vue.use(publishAxios)
Vue.use(toolTipComponent)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    initSdk(this)
    loadExtensionScript()
  }
})



// WEBPACK FOOTER //
// ./src/main.js